/* eslint-disable @typescript-eslint/indent */
import { Button, FormControl, FormErrorMessage, FormLabel, Input, useToast, VStack } from "@chakra-ui/react"
import { useFormik } from "formik"
import React, { FormEvent } from "react"
import { useNavigate } from "react-router-dom"
import * as yup from "yup"
import Lazy from "yup/lib/Lazy"
import Reference from "yup/lib/Reference"
import { AssignTagMutationVariables, ExtendedUserFragment, useAssignTagMutation } from "../graphql"

type AssignTagFormValues = Pick<AssignTagMutationVariables, "tagDecimalId">

const validationSchema = yup.object<Record<keyof AssignTagFormValues, yup.AnySchema<any, any, any> | Reference<unknown> | Lazy<any, any>>>({
	tagDecimalId: yup.string().required().label("Tag ID"),
})

export type AssignTagFormProps = {
	user: ExtendedUserFragment
}

export const AssignTagForm: React.FC<AssignTagFormProps> = ({ user }) => {
	const initialValues: AssignTagFormValues = {
		tagDecimalId: "",
	}

	const [{ fetching }, assignTag] = useAssignTagMutation()

	const toast = useToast()
	const navigate = useNavigate()

	const onSubmit = async ({ tagDecimalId }: AssignTagFormValues) => {
		const { data, error } = await assignTag({ userId: user._id, tagDecimalId })

		if (error) {
			return toast({
				description: error.message.replace("[GraphQL] ", ""),
				status: "error",
			})
		}

		if (data?.assignTag) {
			navigate(`/users/${user._id}`, { replace: true })

			return
		}
	}

	const formik = useFormik<AssignTagFormValues>({ initialValues, validationSchema, onSubmit })

	return (
		<VStack as="form" onSubmit={(e) => formik.handleSubmit(e as unknown as FormEvent<HTMLFormElement>)} w="full" align="stretch" spacing={6}>
			<VStack w="full" align="stretch">
				<FormControl isInvalid={Boolean(formik.touched.tagDecimalId && formik.errors.tagDecimalId)}>
					<FormLabel fontWeight="bold">Tag ID</FormLabel>

					<Input variant="filled" bgColor="grayscale.input-background" placeholder="Enter tag ID" _placeholder={{ color: "grayscale.placeholer" }} {...formik.getFieldProps("tagDecimalId")} />

					<FormErrorMessage>{formik.errors.tagDecimalId}</FormErrorMessage>
				</FormControl>
			</VStack>
			<Button type="submit" colorScheme="primary" isLoading={fetching}>
				Assign
			</Button>
		</VStack>
	)
}
